import { Capacitor } from '@capacitor/core';
import { Haptics } from '@capacitor/haptics';

/* Unified vibration: native Android vibrator inside the Capacitor app
   (navigator.vibrate is silently ignored by the WebView), web API elsewhere.
   Accepts the same ms | [on, off, on, …] pattern as navigator.vibrate. */

const isNative = (() => {
  try { return Capacitor.isNativePlatform() && Capacitor.isPluginAvailable('Haptics'); }
  catch (_) { return false; }
})();

let timers = [];

export const vibrate = (pattern) => {
  if (!isNative) {
    try { navigator.vibrate?.(pattern); } catch (_) { /* unsupported */ }
    return;
  }
  timers.forEach(clearTimeout);
  timers = [];
  const steps = Array.isArray(pattern) ? pattern : [pattern];
  let at = 0;
  steps.forEach((ms, i) => {
    const d = Math.max(0, Number(ms) || 0);
    if (i % 2 === 0 && d > 0) {
      const fire = () => { Haptics.vibrate({ duration: Math.max(10, d) }).catch(() => {}); };
      if (at === 0) fire(); else timers.push(setTimeout(fire, at));
    }
    at += d;
  });
};
